const LOCALES = new Set(["en", "ru", "de", "pt", "zh"]);

const STRINGS = {
  en: {
    aria: {
      quiz: "Weight Quiz",
      dismiss: "Dismiss quiz",
      minimize: "Minimize quiz",
      lives: "{count} lives left",
      open: "Open Weight Quiz"
    },
    bubble: {
      liveLabel: "{count} playing now",
      title: "Quick quiz ⚡",
      question: "{baselineName}: {baselineWeight}. Is {challengeName} {relation}?"
    },
    reveal: {
      right: "✅ Right! +1",
      wrong: "❌ Oof. It was {weight}."
    },
    modal: {
      vs: "vs.",
      baseline: "BASELINE",
      challenge: "CHALLENGE",
      autoNext: "Next round starts automatically...",
      streak: "Streak: {streak}"
    },
    measure: {
      mass: {
        up: "↑ Heavier",
        down: "↓ Lighter",
        question: "Is it heavier or lighter?",
        relation: "heavier or lighter"
      },
      digital: {
        up: "↑ Larger",
        down: "↓ Smaller",
        question: "Is it larger or smaller?",
        relation: "larger or smaller"
      }
    },
    gameover: {
      title: "Game over!",
      streak: "You reached a streak of {streak}",
      share: "📤 Share result",
      playAgain: "🔄 Play again",
      seeAll: "Browse all weights →"
    },
    share: {
      template: "I scored {streak} on Weight Quiz 🏋️\n{emojiGrid}\nBeat me: {url}"
    },
    toast: {
      copied: "Copied to clipboard ✓",
      ready: "Share text ready"
    }
  },
  ru: {
    aria: {
      quiz: "Квиз о весе",
      dismiss: "Закрыть квиз",
      minimize: "Свернуть квиз",
      lives: "Осталось жизней: {count}",
      open: "Открыть квиз о весе"
    },
    bubble: {
      liveLabel: "{count} сейчас играют",
      title: "Быстрый квиз ⚡",
      question: "{baselineName}: {baselineWeight}. {challengeName} {relation}?"
    },
    reveal: {
      right: "✅ Верно! +1",
      wrong: "❌ Упс. Ответ: {weight}."
    },
    modal: {
      vs: "против",
      baseline: "ОРИЕНТИР",
      challenge: "ВОПРОС",
      autoNext: "Следующий раунд начнётся автоматически...",
      streak: "Серия: {streak}"
    },
    measure: {
      mass: {
        up: "↑ Тяжелее",
        down: "↓ Легче",
        question: "Это тяжелее или легче?",
        relation: "тяжелее или легче"
      },
      digital: {
        up: "↑ Больше",
        down: "↓ Меньше",
        question: "Это больше или меньше?",
        relation: "больше или меньше"
      }
    },
    gameover: {
      title: "Игра окончена!",
      streak: "Ваша серия: {streak}",
      share: "📤 Поделиться результатом",
      playAgain: "🔄 Играть снова",
      seeAll: "Смотреть все материалы →"
    },
    share: {
      template: "Мой результат в Weight Quiz: {streak} 🏋️\n{emojiGrid}\nСможешь лучше? {url}"
    },
    toast: {
      copied: "Скопировано ✓",
      ready: "Текст для шаринга готов"
    }
  },
  de: {
    aria: {
      quiz: "Gewichtsquiz",
      dismiss: "Quiz schließen",
      minimize: "Quiz minimieren",
      lives: "{count} Leben übrig",
      open: "Gewichtsquiz öffnen"
    },
    bubble: {
      liveLabel: "{count} spielen gerade",
      title: "Schnelles Quiz ⚡",
      question: "{baselineName}: {baselineWeight}. Ist {challengeName} {relation}?"
    },
    reveal: {
      right: "✅ Richtig! +1",
      wrong: "❌ Uff. Es waren {weight}."
    },
    modal: {
      vs: "gegen",
      baseline: "AUSGANGSWERT",
      challenge: "FRAGE",
      autoNext: "Die nächste Runde startet automatisch...",
      streak: "Serie: {streak}"
    },
    measure: {
      mass: {
        up: "↑ Schwerer",
        down: "↓ Leichter",
        question: "Ist es schwerer oder leichter?",
        relation: "schwerer oder leichter"
      },
      digital: {
        up: "↑ Größer",
        down: "↓ Kleiner",
        question: "Ist es größer oder kleiner?",
        relation: "größer oder kleiner"
      }
    },
    gameover: {
      title: "Spiel vorbei!",
      streak: "Deine Serie: {streak}",
      share: "📤 Ergebnis teilen",
      playAgain: "🔄 Noch einmal spielen",
      seeAll: "Alle Gewichtsguides ansehen →"
    },
    share: {
      template: "Ich habe {streak} im Weight Quiz geschafft 🏋️\n{emojiGrid}\nSchlag mich: {url}"
    },
    toast: {
      copied: "In die Zwischenablage kopiert ✓",
      ready: "Teilen-Text ist bereit"
    }
  },
  pt: {
    aria: {
      quiz: "Quiz de peso",
      dismiss: "Fechar quiz",
      minimize: "Minimizar quiz",
      lives: "{count} vidas restantes",
      open: "Abrir quiz de peso"
    },
    bubble: {
      liveLabel: "{count} jogando agora",
      title: "Quiz rápido ⚡",
      question: "{baselineName}: {baselineWeight}. {challengeName} é {relation}?"
    },
    reveal: {
      right: "✅ Certo! +1",
      wrong: "❌ Opa. Era {weight}."
    },
    modal: {
      vs: "vs.",
      baseline: "REFERÊNCIA",
      challenge: "DESAFIO",
      autoNext: "A próxima rodada começa automaticamente...",
      streak: "Sequência: {streak}"
    },
    measure: {
      mass: {
        up: "↑ Mais pesado",
        down: "↓ Mais leve",
        question: "É mais pesado ou mais leve?",
        relation: "mais pesado ou mais leve"
      },
      digital: {
        up: "↑ Maior",
        down: "↓ Menor",
        question: "É maior ou menor?",
        relation: "maior ou menor"
      }
    },
    gameover: {
      title: "Fim de jogo!",
      streak: "Sua sequência foi {streak}",
      share: "📤 Compartilhar resultado",
      playAgain: "🔄 Jogar novamente",
      seeAll: "Ver todos os guias de peso →"
    },
    share: {
      template: "Fiz {streak} no Weight Quiz 🏋️\n{emojiGrid}\nTente superar: {url}"
    },
    toast: {
      copied: "Copiado para a área de transferência ✓",
      ready: "Texto de compartilhamento pronto"
    }
  },
  zh: {
    aria: {
      quiz: "重量问答",
      dismiss: "关闭问答",
      minimize: "最小化问答",
      lives: "还剩 {count} 条命",
      open: "打开重量问答"
    },
    bubble: {
      liveLabel: "{count} 人正在玩",
      title: "快速问答 ⚡",
      question: "{baselineName}：{baselineWeight}。{challengeName}{relation}？"
    },
    reveal: {
      right: "✅ 答对了！+1",
      wrong: "❌ 哎呀，答案是 {weight}。"
    },
    modal: {
      vs: "对比",
      baseline: "基准",
      challenge: "挑战",
      autoNext: "下一轮将自动开始...",
      streak: "连胜：{streak}"
    },
    measure: {
      mass: {
        up: "↑ 更重",
        down: "↓ 更轻",
        question: "它更重还是更轻？",
        relation: "更重还是更轻"
      },
      digital: {
        up: "↑ 更大",
        down: "↓ 更小",
        question: "它更大还是更小？",
        relation: "更大还是更小"
      }
    },
    gameover: {
      title: "游戏结束！",
      streak: "你的连胜：{streak}",
      share: "📤 分享结果",
      playAgain: "🔄 再玩一次",
      seeAll: "浏览所有重量指南 →"
    },
    share: {
      template: "我在 Weight Quiz 得到 {streak} 分 🏋️\n{emojiGrid}\n来挑战我：{url}"
    },
    toast: {
      copied: "已复制到剪贴板 ✓",
      ready: "分享文本已准备好"
    }
  }
};

export function detectLocale(pathname = window.location.pathname) {
  const prefix = String(pathname).split("/").filter(Boolean)[0];
  return LOCALES.has(prefix) ? prefix : "en";
}

export function getStrings(locale = "en") {
  return STRINGS[LOCALES.has(locale) ? locale : "en"];
}

export function interpolate(template, values = {}) {
  return String(template).replace(/\{(\w+)\}/g, (_match, key) => values[key] ?? "");
}
